import { render, staticRenderFns } from "./chat-message-markdown.vue?vue&type=template&id=3be0ba0a&scoped=true"
import script from "./chat-message-markdown.vue?vue&type=script&lang=js"
export * from "./chat-message-markdown.vue?vue&type=script&lang=js"
import style0 from "./chat-message-markdown.vue?vue&type=style&index=0&id=3be0ba0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0ba0a",
  null
  
)

export default component.exports